export class KanaFilterParameter {
  constructor(public keyword: string = "") {
    this._keyword = KanaFilterParameter.replaceKana(keyword);
  }
  private _keyword: string = "";

  filter(source: string): boolean {
    return !this._keyword
        || (this._keyword === "")
        || (0 <= KanaFilterParameter.replaceKana(source).indexOf(this._keyword));
  }

  clone(): KanaFilterParameter {
    return new KanaFilterParameter(this.keyword);
  }

  private static replaceKana(source: string): string {
    return KanaFilterParameter.hira2kana(KanaFilterParameter.hankana2zenkana(source));
  }

  private static hira2kana(source: string): string {
    return source
      .replace(/[ぁ-ゔ]/g, (s) => {
        return String.fromCharCode(s.charCodeAt(0) + 0x60);
      })
      .replace(/ﾞ/g, "゛")
      .replace(/ﾟ/g, "゜")
      .replace(/(ウ゛)/g, "ヴ")
      .replace(/(ワ゛)/g, "ヷ")
      .replace(/(ヰ゛)/g, "ヸ")
      .replace(/(ヱ゛)/g, "ヹ")
      .replace(/(ヲ゛)/g, "ヺ")
      .replace(/(ゝ゛)/g, "ヾ")
      .replace(/ゝ/g, "ヽ")
      .replace(/ゞ/g, "ヾ");
  }

  private static hankana2zenkana(source: string): string {
    const reg = new RegExp("(" + Object.keys(KanaFilterParameter.kanaMap).join("|") + ")", "g");
    return source
      .replace(reg, (match) => {
        return KanaFilterParameter.kanaMap[match];
      })
      .replace(/ﾞ/g, "゛")
      .replace(/ﾟ/g, "゜");
  }

  private static readonly kanaMap: { [key: string]: string } = {
    "ｶﾞ": "ガ", "ｷﾞ": "ギ", "ｸﾞ": "グ", "ｹﾞ": "ゲ", "ｺﾞ": "ゴ",
    "ｻﾞ": "ザ", "ｼﾞ": "ジ", "ｽﾞ": "ズ", "ｾﾞ": "ゼ", "ｿﾞ": "ゾ",
    "ﾀﾞ": "ダ", "ﾁﾞ": "ヂ", "ﾂﾞ": "ヅ", "ﾃﾞ": "デ", "ﾄﾞ": "ド",
    "ﾊﾞ": "バ", "ﾋﾞ": "ビ", "ﾌﾞ": "ブ", "ﾍﾞ": "ベ", "ﾎﾞ": "ボ",
    "ﾊﾟ": "パ", "ﾋﾟ": "ピ", "ﾌﾟ": "プ", "ﾍﾟ": "ペ", "ﾎﾟ": "ポ",
    "ｳﾞ": "ヴ", "ﾜﾞ": "ヷ", "ｦﾞ": "ヺ",
    "ｱ": "ア", "ｲ": "イ", "ｳ": "ウ", "ｴ": "エ", "ｵ": "オ",
    "ｶ": "カ", "ｷ": "キ", "ｸ": "ク", "ｹ": "ケ", "ｺ": "コ",
    "ｻ": "サ", "ｼ": "シ", "ｽ": "ス", "ｾ": "セ", "ｿ": "ソ",
    "ﾀ": "タ", "ﾁ": "チ", "ﾂ": "ツ", "ﾃ": "テ", "ﾄ": "ト",
    "ﾅ": "ナ", "ﾆ": "ニ", "ﾇ": "ヌ", "ﾈ": "ネ", "ﾉ": "ノ",
    "ﾊ": "ハ", "ﾋ": "ヒ", "ﾌ": "フ", "ﾍ": "ヘ", "ﾎ": "ホ",
    "ﾏ": "マ", "ﾐ": "ミ", "ﾑ": "ム", "ﾒ": "メ", "ﾓ": "モ",
    "ﾔ": "ヤ", "ﾕ": "ユ", "ﾖ": "ヨ",
    "ﾗ": "ラ", "ﾘ": "リ", "ﾙ": "ル", "ﾚ": "レ", "ﾛ": "ロ",
    "ﾜ": "ワ", "ｦ": "ヲ", "ﾝ": "ン",
    "ｧ": "ァ", "ｨ": "ィ", "ｩ": "ゥ", "ｪ": "ェ", "ｫ": "ォ",
    "ｯ": "ッ", "ｬ": "ャ", "ｭ": "ュ", "ｮ": "ョ",
    "｡": "。", "､": "、", "ｰ": "ー", "｢": "「", "｣": "」", "･": "・"
  };
}
